module.exports = __webpack_public_path__ + "img/teacher.5682fe2.png";